<div [ngClass]="tabsService.minimizeScreenMode ? 'bottom-menu minimized' : ''"
     [ngStyle]="{ 'display' : mapSearchController.active? 'block' : 'none'}">
  <ng-container *ngIf="['Navaid','Coordinate Point'].includes(searchDomain)">
    <form autocomplete="off"  id="ngMapSearchController" [ngClass]="[this.mapSearchController.active ? 'active' : '',  tabsService.fullScreenMode ? 'fullscreen' : '']" name="ngMapSearchController" #ngngHorizonToolController="ngForm" id="apSearchForm" style="height: 600px">
      <div class="fields__block small">
        <div class="fields__block__section">
          <div class="title">
            <h4 style="width: 50%;">Search Parameters</h4>
            <span> </span>
          </div>
          <div class="dropdown-fields">
            <div>
              <label for="">Domain</label>
              <select #domain id="domainSelect" (change)="showFields(domain.value);changeInputType(domain.value,field.value)"
                      [(ngModel)]="searchDomain" name="searchDomain">
                <option value="Navaid">Navaid</option>
                <option value="Coordinate Point">Coordinate Point</option>

                <option [value]="FeatureType.Device">{{ FeatureType.Device }}</option>
<!--                <option [value]="FeatureType.Receiver">{{ FeatureType.Receiver }}</option>-->
                <option [value]="FeatureType.InterferenceTest">{{ FeatureType.InterferenceTest }}</option>
                <option [value]="FeatureType.Radar">{{ FeatureType.Radar }}</option>
              </select>
            </div>
            <div>
              <label for="">Field</label>
              <select  #field name="field" id="fieldSelect" (change)="changeInputType(domain.value,field.value)">
                <option *ngFor="let field of this.fields" value="{{field}}">{{field}}</option>
              </select>
            </div>
          </div>
          <div class="input-fields">
            <div>
              <label for="">Search</label>
              <input name="field_text" type="text" *ngIf="field.value != 'Type' && field.value != 'User Defined'" [(ngModel)]="text_value"/>
              <select  #field name="field_combo" id="fieldSelectCombo" *ngIf="field.value == 'Type' || field.value == 'User Defined'" [(ngModel)]="text_value">
                <option *ngFor="let field of this.dropdown_options" value="{{field}}">{{field}}</option>
              </select>
            </div>
          </div>
          <div class="table-fields">
            <div>
              <div class="btn" style="cursor: default; padding: 10px 0;">
                <div style=" padding: 0;">
                  <a (click)="applySearch(domain.value, field.value)">Search</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="fields__block large">
        <div class="fields__block__section">
          <div class="title">
            <h4 style="width: auto;">Results</h4>
            <span style="width: 90%;"> </span>
          </div>
          <div class="table-fields" *ngIf="domain.value == 'Coordinate Point'">
            <div style="height: 376px;overflow-y: auto;">
              <table>
                <thead>
                <tr>
                  <th scope="col">Id</th>
                  <th scope="col">Name</th>
                  <th scope="col">Type</th>
                  <th scope="col">Latitude</th>
                  <th scope="col">Longitude</th>
                  <th scope="col">User Defined</th>
                  <th scope="col">Max Altitude</th>
                  <th scope="col">Min Altitude</th>
                  <th scope="col">Nominal Altitude</th>
                </tr>
                </thead>
                <tbody>
                <tr mdbTableCol *ngFor="let el of mapSearchController.coordinatePoints; let i = index" (click)="selectCoordinatePointRow(el)" [class.highlighted]="el.isselected">
                  <td>{{ el.coordpointid }}</td>
                  <td>{{ el.name }}</td>
                  <td>{{ el.type }}</td>
                  <td>{{ el.latitude }}</td>
                  <td>{{ el.longitude }}</td>
                  <td>{{ !el.userdefined }}</td>
                  <td>{{ el.maxaltitude }}</td>
                  <td>{{ el.minaltitude }}</td>
                  <td>{{ el.nominalaltitude }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="table-fields" *ngIf="domain.value == 'Navaid'">
            <div style="height: 376px;overflow-y: auto;">
              <table>
                <thead>
                <tr>
                  <th scope="col">Id</th>
                  <th scope="col">Name</th>
                  <th scope="col">Type</th>
                  <th scope="col">Latitude</th>
                  <th scope="col">Longitude</th>
                  <th scope="col">Elevation</th>
                  <th scope="col">DOC</th>
                  <th scope="col">Max Altitude</th>
                  <th scope="col">User Defined</th>
                  <th scope="col">Icao Contry Code</th>
                  <th scope="col">Channel</th>
                </tr>
                </thead>
                <tbody>
                <tr mdbTableCol *ngFor="let el of mapSearchController.navaids; let i = index" (click)="selectNavaidRow(el)"
                    [class.highlighted]="el.isselected">
                  <td>{{ el.navaidid }}</td>
                  <td>{{ el.name }}</td>
                  <td>{{ el.navaidtype }}</td>
                  <td>{{ el.latitude }}</td>
                  <td>{{ el.longitude }}</td>
                  <td>{{ el.elevation }}</td>
                  <td>{{ el.doc }}</td>
                  <td>{{ el.maxaltitude }}</td>
                  <td>{{ !el.userdefined }}</td>
                  <td>{{ el.icaocc }}</td>
                  <td>{{ el.channel }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </form>
  </ng-container>

  <ng-container *ngIf="!['Navaid','Coordinate Point'].includes(searchDomain)">
    <form #form="ngForm"
          [ngClass]="[this.mapSearchController.active ? 'active' : '',  tabsService.fullScreenMode ? 'fullscreen' : '']"
          autocomplete="off" style="height: 600px">

      <div class="fields__block small">
        <div class="fields__block__section">
          <div class="title">
            <h4 style="width: 50%;">Search Parameters</h4>
            <span> </span>
          </div>
          <div class="dropdown-fields">
            <div>
              <label for="domainSelect">Domain</label>
              <select [(ngModel)]="searchDomain" name="searchDomain">
                <option value="Navaid">Navaid</option>
                <option value="Coordinate Point">Coordinate Point</option>

                <option [value]="FeatureType.Device">{{ FeatureType.Device }}</option>
<!--                <option [value]="FeatureType.Receiver">{{ FeatureType.Receiver }}</option>-->
                <option [value]="FeatureType.InterferenceTest">{{ FeatureType.InterferenceTest }}</option>
                <option [value]="FeatureType.Radar">{{ FeatureType.Radar }}</option>
              </select>
            </div>

            <div>
              <label for="">Field</label>
              <select [(ngModel)]="searchIndex" id="searchIndex" name="searchIndex" required>
                <option *ngFor="let field of search.options; index as i" value="{{i}}">{{ field.display }}</option>
              </select>
            </div>
          </div>

          <div class="input-fields">
            <ng-container *ngFor="let input of search.options[searchIndex]?.value.inputs; index as i">
              <div>
                <label [for]="'value_'+i">{{input.field}}</label>

                <ng-container [ngSwitch]="input.type">
                  <select *ngSwitchCase="'dropdown'" [id]="'value_'+i" [name]="'value_'+i" required
                          [(ngModel)]="search.values[i]">
                    <option *ngFor="let item of input.value()" [value]="item.value">{{ item.display }}</option>
                  </select>

                  <input *ngSwitchDefault [id]="'value_'+i" [name]="'value_'+i" required [value]="input.value()"
                         [(ngModel)]="search.values[i]" [type]="input.type"/>

                </ng-container>
              </div>
            </ng-container>
            <div class="btn" style="cursor: default; padding: 10px 0;">
              <div style=" padding: 0;">
                <button (click)="gritApplySearch()" [disabled]="!form.form.valid">Search</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="fields__block large">
        <div class="fields__block__section">
          <div class="title">
            <h4 style="width: auto;">Results {{searchDomain}}</h4>
            <span style="width: 90%;"> </span>
          </div>

          <app-grit-dynamic-table-features
            (selectedRowEvent)="gritSelectRow($event)"
            [features]="mapSearchController.gritSearched.elements"
            [mode]="GritDynamicTableMode.SELECT"
            [type]="GritDynamicTableType.COMPLETE">
          </app-grit-dynamic-table-features>

          <div *ngIf="this.mapSearchController.gritSearched.elements?.length == 0">
            No entities found...
          </div>
        </div>
      </div>
    </form>
  </ng-container>
</div>
